import HomeIcon from '@mui/icons-material/HomeRounded';
import CollaborateurIcon from '@mui/icons-material/AccountBoxRounded';
import AffaireIcon from '@mui/icons-material/WorkOutlineRounded';
import ClientIcon from '@mui/icons-material/HomeWorkRounded';
import ActiviteIcon from '@mui/icons-material/ScheduleRounded';
import StatistiqueIcon from '@mui/icons-material/EqualizerRounded';
import KanbanIcon from '@mui/icons-material/ViewKanbanRounded';
import AgendaIcon from '@mui/icons-material/CalendarMonthRounded';
import AdministrationIcon from '@mui/icons-material/ConstructionRounded';
import HelpIcon from '@mui/icons-material/HelpOutlineRounded';
import UpIcon from '@mui/icons-material/ArrowDropUpRounded';
import DownIcon from '@mui/icons-material/ArrowDropDownRounded';
import RefreshIcon from '@mui/icons-material/LoopRounded';
import SearchIcon from '@mui/icons-material/SearchRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import ContactIcon from '@mui/icons-material/PermContactCalendarRounded';
import EquipeIcon from '@mui/icons-material/Groups2Rounded';
import EditIcon from '@mui/icons-material/EditRounded';
import CommentaireIcon from '@mui/icons-material/MessageRounded';
import EmailIcon from '@mui/icons-material/AlternateEmailRounded';
import PhoneIcon from '@mui/icons-material/PhoneEnabledRounded';
import MobileIcon from '@mui/icons-material/PhoneAndroidRounded';
import AddIcon from '@mui/icons-material/AddCircleRounded';
import OpenIcon from '@mui/icons-material/LockOpenRounded';
import MenuIcon from '@mui/icons-material/MenuRounded';
import UtilisateurIcon from '@mui/icons-material/AccountCircleRounded';
import DeleteIcon from '@mui/icons-material/DeleteForeverRounded';
import DeconnexionIcon from '@mui/icons-material/LogoutRounded';
import ConnexionIcon from '@mui/icons-material/LoginRounded';
import LocationIcon from '@mui/icons-material/LocationOn';
import LocationOffIcon from '@mui/icons-material/LocationOffRounded';
import ExpandIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessIcon from '@mui/icons-material/ExpandLessRounded';
import StarIcon from '@mui/icons-material/StarBorderPurple500Rounded';
import UsurpationIcon from '@mui/icons-material/PolicyRounded';
import VisionIcon from '@mui/icons-material/VisibilityRounded';
import ExportIcon from '@mui/icons-material/FileDownloadRounded';
import ImportIcon from '@mui/icons-material/FileUploadRounded';
import DisplayIcon from '@mui/icons-material/PlagiarismRounded';
import DocumentIcon from '@mui/icons-material/AttachFileRounded';
import CopyIcon from '@mui/icons-material/ContentCopyRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import ObjectifIcon from '@mui/icons-material/TrendingUpRounded';
import AnalyseIcon from '@mui/icons-material/PageviewRounded';
import NegociationIcon from '@mui/icons-material/CasesRounded';
import ConclusionIcon from '@mui/icons-material/HandshakeRounded';
import ClotureIcon from '@mui/icons-material/CheckCircleRounded';
import InfoIcon from '@mui/icons-material/InfoRounded';
import LeftIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import RightIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import EuroIcon from '@mui/icons-material/EuroRounded';
import PercentIcon from '@mui/icons-material/PercentRounded';
import NumberIcon from '@mui/icons-material/NumbersRounded';
import IdentityIcon from '@mui/icons-material/PermIdentityRounded';
import TagIcon from '@mui/icons-material/LocalOfferRounded';
import TypeIcon from '@mui/icons-material/FormatListBulletedRounded';
import ProfessionelIcon from '@mui/icons-material/AccountBalanceRounded';
import SignatureIcon from '@mui/icons-material/QueryStatsRounded';
import DateStartIcon from '@mui/icons-material/HourglassEmptyRounded';
import DateEndIcon from '@mui/icons-material/HourglassFullRounded';
import LibelleIcon from '@mui/icons-material/TitleRounded';
import EtatIcon from '@mui/icons-material/AccessAlarmRounded';
import ResultatIcon from '@mui/icons-material/FlagCircleRounded';
import DureeIcon from '@mui/icons-material/TimerOutlined';
import PeriodeIcon from '@mui/icons-material/DateRangeRounded';
import CatalogueIcon from '@mui/icons-material/AdjustRounded';
import UniteIcon from '@mui/icons-material/AbcRounded';
import ResetPasswordIcon from '@mui/icons-material/PasswordRounded';
import MargeIcon from '@mui/icons-material/TrendingUpRounded';
import PortfefeuilleIcon from '@mui/icons-material/WalletRounded';
import CreationPortefeuilleIcon from '@mui/icons-material/AddShoppingCartRounded';
import MoveIcon from '@mui/icons-material/MoveUpRounded';
import MapIcon from '@mui/icons-material/PinDropRounded';
import LicenceIcon from '@mui/icons-material/WorkspacePremiumRounded';
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import SaveIcon from '@mui/icons-material/SaveRounded';
import ExecIcon from '@mui/icons-material/PlayCircleFilledWhiteRounded';
import PasswordIcon from '@mui/icons-material/KeyRounded';
import StopIcon from '@mui/icons-material/HighlightOffRounded';
import LooseIcon from '@mui/icons-material/BlockRounded';
import StarsIcon from '@mui/icons-material/AutoAwesomeRounded';
export { ErrorIcon, SaveIcon, ExecIcon, HomeIcon, CollaborateurIcon, AffaireIcon, ClientIcon, ActiviteIcon, StatistiqueIcon, AgendaIcon, KanbanIcon, AdministrationIcon, HelpIcon, UpIcon, DownIcon, RefreshIcon, SearchIcon, CloseIcon, ContactIcon, EquipeIcon, EditIcon, CommentaireIcon, EmailIcon, PhoneIcon, MobileIcon, AddIcon, AnalyseIcon, NegociationIcon, ConclusionIcon, ClotureIcon, OpenIcon, MenuIcon, UtilisateurIcon, DeleteIcon, DeconnexionIcon, ConnexionIcon, LeftIcon, RightIcon, EuroIcon, PercentIcon, NumberIcon, LocationIcon, ExpandIcon, ExpandLessIcon, StarIcon, UsurpationIcon, ExportIcon, DisplayIcon, DocumentIcon, ImportIcon, InfoIcon, CopyIcon, SendIcon, VisionIcon, ResetPasswordIcon, MargeIcon, PortfefeuilleIcon, CreationPortefeuilleIcon, MoveIcon, MapIcon, LicenceIcon, StopIcon, LooseIcon, SignatureIcon, LocationOffIcon, ObjectifIcon, CatalogueIcon, StarsIcon, };
export var FieldIcons = {
    TypeId: TypeIcon,
    CollaborateurId: CollaborateurIcon,
    ClientId: ClientIcon,
    Civilite: IdentityIcon,
    Nom: IdentityIcon,
    Prenom: IdentityIcon,
    Email: EmailIcon,
    Telephone: PhoneIcon,
    Mobile: MobileIcon,
    Adresse: LocationIcon,
    CodePostal: LocationIcon,
    Ville: LocationIcon,
    Pays: LocationIcon,
    Tags: TagIcon,
    Commentaire: CommentaireIcon,
    Details: CommentaireIcon,
    Siret: ProfessionelIcon,
    RaisonSociale: ProfessionelIcon,
    CodeNafApeId: TypeIcon,
    TrancheEffectif: TypeIcon,
    OnlyMonthMoisSignature: SignatureIcon,
    OnlyYearMoisSignature: SignatureIcon,
    DateDebut: DateStartIcon,
    DateFin: DateEndIcon,
    Libelle: LibelleIcon,
    Etat: EtatIcon,
    Resultat: ResultatIcon,
    DureeActivite: DureeIcon,
    Periode: PeriodeIcon,
    Quantite: NumberIcon,
    Tarif: EuroIcon,
    Cout: EuroIcon,
    Pourcentage: PercentIcon,
    Unite: UniteIcon,
    CatalogueId: CatalogueIcon,
    Login: UtilisateurIcon,
    Password: PasswordIcon,
    Societe: ProfessionelIcon,
};
//# sourceMappingURL=Icons.js.map